import "./structureDatasheet.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { roofStructureData } from "../Design&Structure/structureFunction";

const StructureDatasheet = (props) => {
  const { tableContent, structureName, index } = props;
  
  const pageDetail = tableContent.find(
    (item) => item.title === "Product Data Sheets"
  );
  const structureDetail = roofStructureData.find(
    (item) => item.name === structureName
  );

  let page = pageDetail?.pageNo || 0;
  let pageNo = page + index;


  return (
    <div id="structure-datasheet" className="structure-datasheet">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header/>
      {/* Main Body */}
      <main className="sd-body">
        <p>Structure</p>
        <img
          className="img"
          src={structureDetail.structureDataSheet}
          alt={structureDetail.name}
        ></img>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageNo}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default StructureDatasheet;
